import { t } from "../../hooks/useAppTranslation";
import CSS from "csstype";
import { useHistory } from "react-router-dom";

type Props = {
  abortPath?: string;
  align?: "center" | "left" | "right";
  context?: boolean;
  disabled: boolean;
};

export const FormActionButtons: React.FC<Props> = ({
  abortPath,
  align,
  context,
  disabled,
}) => {

  const history = useHistory();

  const alignStyle: CSS.Properties = {
    textAlign: align ? align : "right",
  };

  return (
    <div className='btn_group' style={alignStyle}>
      <button
        className='btn save-btn uppercase'
        id='save_button'
        type='submit'
        disabled={disabled}
      >
        {t('g-save')}{context && <span className="sr-only"> {context}</span>}
      </button>
      <button
        className='btn cancel-btn uppercase'
        type='button'
        onClick={() => (abortPath ? history.push(abortPath) : history.goBack())}
        disabled={disabled}
      >
        {t('g-cancel')}
      </button>
    </div>
  );
};
